<div id="wrapper">
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    <div>
        <app-tab-nav (updatePostpaid)="this.postpago=$event" 
            (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event" 
            (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event" 
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="allcont logsize" *ngIf="this.totalAccountList > 0">
        <div class="basicrow m-top-i">
            <div class="container">
                <div class="basicr-line-i marTopRes">
                    <div class="fulltitle f-btitle autodef">
                      <span class="icon-dash-01"></span> Débito directo
                    </div>
                    <div class="pull-right">
                      <label class="label-r sidenmbr vcenter w-auto">
                        <span class="tabcell">
                          N&uacute;mero de Cuenta
                        </span>
                      </label>
                      <div class="autorow subsc  mob-wid pull-right">
                        <div>
                            <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(../../assets/images/selectabarrw.png)">
                                <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                    {{list.account}}</option>
                            </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--
                <div class="basicr-line-i">
                    <div class="fulltitle  f-btitle autodef">
                        <span class="icon-dash-01"></span> Débito directo
                    </div>
                    <div class="pull-right">
                        <div class="autorow subsc  mob-wid pull-right">
                            <div >
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                                </select>
                            </div>
                        </div>
                    </div> 
                    <div class="pull-right pull-right-top m-wid-d">
                        <label class="label-r sidenmbr vcenter w-auto">
                                <span class="tabcell">
                                    N&uacute;mero de Cuenta
                                </span>
                            </label>
                        <div class="mob-wid pull-right">
                            <div>
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(../../assets/images/selectabarrw.png)">
                                        <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                            {{list.account}}</option>
                                    </select>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
        <div class="basicrow mbott-i">
            <div class="container">
                <div class="basicrow m-top-i mbott-i gap-b-mobile gap-a-mobile m-l-direct">
                    <div class="">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-md-offset-1 col-lg-offset-1">
                            <app-affiliate-check 
                                [screen]="this.screen" 
                                [tiposPago]="this.tiposPago"
                                [infoAfiliation]="this.infoAfiliation" 
                                (updateScreen)="this.screen=$event"
                                (updatetipo)="this.tiposPago=$event">
                            </app-affiliate-check>
                            <app-resume-check 
                                [screen]="this.screen" 
                                [infoAfiliation]="this.infoAfiliation"
                                [bank]="this.bank" 
                                [affiliate]="this.affiliate">
                            </app-resume-check>
                            <app-affiliate-credit 
                                [screen]="this.screen" 
                                [tiposPago]="this.tiposPago"
                                [infoAfiliation]="this.infoAfiliation" 
                                [typeCard]="this.typeCard"
                                (updateScreen)="this.screen=$event" 
                                (updatetipo)="this.tiposPago=$event">
                            </app-affiliate-credit>
                            <app-resume-credit 
                                [screen]="this.screen" 
                                [infoAfiliation]="this.infoAfiliation"
                                [affiliate]="this.affiliate" 
                                [typeCard]="this.typeCard">
                            </app-resume-credit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>